export default __webpack_public_path__ + "static/media/audience.8001c87e.csv";